export default "__VITE_PUBLIC_ASSET__678dabd9__"